const OPEN_STATE_MAP = {
  NOT_OPEN: 1,
  OPENING: 2,
  OPENED: 3,
  OPEN_FAIL: 4,
  AUDIT_SUCCESS: 5,
}

const ACCOUNT_STATE_MAP = {
  DISABLE: 0,
  ENABLED: 1,
}

const SIGN_STATE_MAP = {
  CONFIRM: 0, // 已发送签约短信，但是还未签署
  SIGNED: 1, // 完全签署完成
  TERMINATED: 2, // 已解约
  NOT_START: 99, // 99 待签约
  WAIT_TO_SCAN: 10, // 合同已签署，等待支付宝扫码
}

const openStateList = {
  1: '未开通',
  2: '开通中',
  3: '已开通',
  4: '开通失败',
  5: '审核成功',
}

export { ACCOUNT_STATE_MAP, OPEN_STATE_MAP, openStateList, SIGN_STATE_MAP }
